import {
  FAQS,
  AnalyticsHeader,
  TERMS_AND_CONDITION,
  TERMS_AND_CONDITION_ADD_ON,
  TERMS_AND_CONDITION_OPT_OUT_RESTRICTED,
} from "./helper";
import { routes } from "src/shared/routes";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

export const sanjosesharks_pass: TTeamConfig = {
  TEAM_SCHEMA: "sanjosesharks_pass",
  TEAM_FULL_NAME: "San Jose Sharks",
  BROWSER_TITLE: "San Jose Sharks",
  CLIENT_ID: "d936ca0a52e7.seasonshare.sharks-sharks.us",

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#006D75",
    COLORS_SECONDARY: "#EA7200",
    ANALYTICS_HEADER: AnalyticsHeader,
    IS_INTERCOM_ENABLED: true,
    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
    },
    LOGOUT_ON_INVALID_SESSION: false,
    DEFAULT_APP_ROUTE: routes.landing,
    FOOTER: {
      BACKGROUND_COLOR: "#006D75",
    },
  },

  HOME_PAGE_SETTINGS: {
    EVENT_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
    },

    ADD_ON: {
      ADD_SERVICE_FEE_TO_PRICE: true,
    },
  },

  LANDING_PAGE_SETTINGS: {
    PASS_BANNER: {
      PASS_DISPLAY_MODE: "separate",
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },
    PASS: {
      ADD_SERVICE_FEE_TO_PRICE: true,
      HIDE_DECIMAL_POINTS_AFTER_PRICE: true,
      SHOW_FAQ_BUTTON: true,
      HIDE_PASS_PRICE: true,
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
    },
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    SUBSCRIPTION_DETAILS: {
      HIDE_RESUME_SUBSCRIPTION_BUTTON: true,
    },
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  IMAGES: {
    LOGO_URL:
      "https://ss-leagues.s3.amazonaws.com/Utahjazz%20Assets/sharks_pass_logo.png",
    ORDER_SUMMERY_BACKGROUND_URL:
      "https://ss-leagues.s3.amazonaws.com/NHL_2024_v3/San%20Jose%20Sharks%20Pass%20Assets/SJS_24_Breakaway_Background02.png",
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
    TERMS_AND_CONDITION_OPT_OUT_RESTRICTED,
    TERMS_AND_CONDITION_ADD_ON,
    PRE_PURCHASE_FAQS: FAQS,
  },
};
